module.exports = __webpack_public_path__ + "static/media/note.31380351.svg";